import { render } from "./TipoIden_Empresa.vue?vue&type=template&id=7c3db7e8"
import script from "./TipoIden_Empresa.vue?vue&type=script&lang=js"
export * from "./TipoIden_Empresa.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__